import type {ReactElement} from 'react';
import React from 'react';
import {isEditorMobileVariant} from '@Components/poster-editor/library/poster-editor-library';
import {EDITOR_LEFT_MARGIN} from '@Components/poster-editor/library/poster-editor-scrolling-library';
import {useAppSelector} from '@/hooks';
import {PosterModeType} from '@PosterWhiteboard/poster/poster-mode.class';

export function FloatyEditorLeftMargin(): ReactElement<any> | null {
  const isInGeneration = useAppSelector((state) => {
    return state.posterEditor.posterObject?.mode.details.type === PosterModeType.GENERATE;
  });
  const isWebPage = useAppSelector((state) => {
    return state.posterEditor.posterObject?.mode.details.type === PosterModeType.WEB_PAGE;
  });

  if (isEditorMobileVariant() || isInGeneration || isWebPage) {
    return null;
  }

  return (
    <div
      style={{
        width: `${EDITOR_LEFT_MARGIN}px`,
        minWidth: `${EDITOR_LEFT_MARGIN}px`,
        height: '100%',
      }}
    />
  );
}
